export const isShipmentDeleted = (shipment) => Boolean(shipment?.is_deleted)

export const shipmentDeletedRowClass = (shipment, extra = '') => {
  const base = extra || ''
  if (!isShipmentDeleted(shipment)) return base
  return `${base} line-through text-gray-400 decoration-gray-500`.trim()
}
